import autobind from 'core-decorators/lib/autobind';
import { intlShape } from 'react-intl';
import decorate from 'core-decorators/lib/decorate';

import { WixConnect } from 'shared/utils/wix-connect';

import { WidgetDropdown } from 'shared/components/dropdown/dropdown';

import styles from './categories.styl';

import translations from './translations';


@WixConnect()
export default class Categories extends React.Component {

  static propTypes = {
    className: React.PropTypes.string,
    list: React.PropTypes.arrayOf(React.PropTypes.string),
    onCategorySelect: React.PropTypes.func,
    selectedCategory: React.PropTypes.string,
    height: React.PropTypes.number,
    biEvent: React.PropTypes.func,
    intl: intlShape,
    DropdownClass: React.PropTypes.func,
  };

  static defaultProps = {
    selectedCategory: null,
    DropdownClass: WidgetDropdown,
  };

  @decorate(_.memoize)
  getOptions(list) {
    const options = _.map(list, value => ({ label: value, value }));
    return [
      {
        label: this.props.intl.formatMessage(translations.allVideos),
        value: null,
      },
      ...options,
    ];
  }

  sendCategorySelectedBI() {
    this.props.biEvent('widget.categories.selected');
  }

  @autobind
  sendCategoriesClickedBI() {
    this.props.biEvent('widget.categories.clicked');
  }

  @autobind
  handleChange(value) {
    this.sendCategorySelectedBI();
    this.props.onCategorySelect(value);
  }

  render() {
    const { className, selectedCategory, DropdownClass, height, list } = this.props;

    return (
      <DropdownClass className={`${className} qa-widget-categories`}
                     optionsClassName={styles.options}
                     optionClassName={styles.option}
                     height={height}
                     onChange={this.handleChange}
                     onOpen={this.sendCategoriesClickedBI}
                     value={selectedCategory}
                     options={this.getOptions(list)} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/categories/categories.js